export default __webpack_public_path__ + "static/media/USDT-BUSD.8d437fc2.png";